/**
 * SASS
 */
require('./stylesheets/frontend/style.scss');

/**
 * JS
 */
require('./js/includes/slick.js');
require('./js/custom/scripts.js');
